var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheckWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.6096 5.83488C8.20448 6.32663 5.84276 9.48563 6.33451 12.8907C6.82626 16.2958 9.98526 18.6575 13.3903 18.1658C16.7954 17.674 19.1571 14.515 18.6654 11.1099C18.6654 11.1099 19.7234 9.87924 19.8754 9.7265C20.018 9.97989 20.15 10.8955 20.15 10.8955C20.7601 15.1205 17.8297 19.0402 13.6047 19.6503C9.37974 20.2605 5.46007 17.3301 4.84991 13.1051C4.23975 8.88011 7.17015 4.96045 11.3951 4.35028C13.432 4.05612 15.3995 4.58565 16.9572 5.68549L16.092 6.91083C14.8352 6.02348 13.2518 5.59772 11.6096 5.83488Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5498 11.5L12.5498 15L19.5 6.5",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckWhite);
export default __webpack_public_path__ + "static/media/check-white.00df4df29c08b135b9ebf239476e39a0.svg";
export { ForwardRef as ReactComponent };